import { ElMessage } from "element-plus";

import {
  getMockUrl,
  getPrefixUrl,
  getOpenAccessTokenKey,
  mockJwtMap,
  checkMallFetchUrl,
  checkShopFetchUrl,
  checkCollectionFetchUrl,
  getMallAppToken,
  getToken,
  setMallAppToken,
  setToken,
} from "../utils/globalData";
import { useMainStore } from "../composables/store";
import { batchTranslateTexts } from "../api/mall";
import {
  applyTransferTranslations,
  getHeaderValue,
  getCurrentLocaleTransferCode,
  resolveTransferRequestConfig,
  resolveCurrentTransferLanguage,
} from "../utils/transferTranslation";


import { get } from "lodash-es";

const responseMessageTranslationCache = new Map();

async function translateResponseMessage(message = "", authorization = "") {
  const normalizedMessage = String(message || "").trim();
  if (!process.client || !normalizedMessage) {
    return normalizedMessage;
  }

  const currentLocale = String(resolveCurrentTransferLanguage() || "").trim();
  if (!currentLocale || currentLocale.toLowerCase().startsWith("zh")) {
    return normalizedMessage;
  }

  const targetLanguage = getCurrentLocaleTransferCode(currentLocale);
  if (!targetLanguage) {
    return normalizedMessage;
  }

  const cacheKey = `${targetLanguage}__${normalizedMessage}`;
  if (responseMessageTranslationCache.has(cacheKey)) {
    return responseMessageTranslationCache.get(cacheKey);
  }

  try {
    const translateResponse = await batchTranslateTexts(
      {
        isSystemText: 0,
        texts: [normalizedMessage],
        sourceLanguage: "zh",
        targetLanguage,
        appType: "react-mall-app",
      },
      authorization
    );

    const translatedMessage = String(
      get(translateResponse, "data.results[0].translatedText") ||
        get(translateResponse, "data.data.results[0].translatedText") ||
        get(translateResponse, "data.result") ||
        normalizedMessage
    ).trim() || normalizedMessage;

    responseMessageTranslationCache.set(cacheKey, translatedMessage);
    return translatedMessage;
  } catch (error) {
    return normalizedMessage;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const customFetch = async (url, options = {}) => {
    const store = useMainStore();
    const headers = useRequestHeaders();
    let hostSite =headers?.referer &&
        headers.referer
          .replace("http://", "")
          .replace("https://", "")
          .split("/")[0];

    if (headers?.host) {
      hostSite = headers.host;
    }

    if (headers?.["x-custom-header1"]) {
      hostSite = headers["x-custom-header1"];
    }

    if (process.client) {
      hostSite = window.location.host;
    }
    if(getMockUrl()){
      hostSite=getMockUrl();
    }

    const tokenKey = getOpenAccessTokenKey(hostSite);

    // 设置默认请求头
    const defaultHeaders = {
      ...options.headers,
    };

    // 如果有 mockJwtMap 或 store 中的 token，将其添加到请求头
    if (mockJwtMap[getPrefixUrl()]) {
      defaultHeaders["openaccessjwt"] = mockJwtMap[getPrefixUrl()];
    }

    if (store && store.$state.tokenKeyMap[tokenKey]) {
      defaultHeaders["openaccessjwt"] = store.$state.tokenKeyMap[tokenKey];
    }
    
    if (store && store.$state.shopIdKeyMap[tokenKey]) {
      defaultHeaders["shopId"] = store.$state.shopIdKeyMap[tokenKey];
    }

    const transferRequestConfig = resolveTransferRequestConfig(
      defaultHeaders,
      options.body
    );


    // 请求方法和参数处理
    let fetchOptions = {
      ...options,
      headers: defaultHeaders,
      baseURL: getPrefixUrl(),
    };

    if (process.client) {
      // 客户端登录信息管理
      let isShopUrl = checkShopFetchUrl(url);
      let isMallUrl = checkMallFetchUrl(url);
      let isCollectionUrl = checkCollectionFetchUrl(url);
      if(isShopUrl){
        const token = getToken();
        if (typeof fetchOptions.headers != "undefined") {
          if (typeof token === "string") {
            fetchOptions.headers.authorization = token;
          } else {
            fetchOptions.headers.authorization = "";
          }
        }
      } else if (isMallUrl) {
        fetchOptions.headers.authorization = getMallAppToken();
      } else if (isCollectionUrl) {
        const token = getToken();
        if (typeof fetchOptions.headers != "undefined") {
          if (typeof token === "string") {
            fetchOptions.headers.authorization = token;
          } else {
            fetchOptions.headers.authorization = "";
          }
        }
      }
    }

    try {
      // 发送请求
      const response = await $fetch.raw(url, fetchOptions);
      const resHeaders = response.headers;
      const authorizationData = getHeaderValue(resHeaders, "authorization");
      if (process.client && authorizationData) {
        // 客户端登录信息管理
        let isShopUrl = checkShopFetchUrl(url);
        let isMallUrl = checkMallFetchUrl(url);
        let isCollectionUrl = checkCollectionFetchUrl(url);
        if (isMallUrl) {
          setToken(authorizationData);
        } else if (isCollectionUrl) {
          setMallAppToken(authorizationData);
        }else if(isShopUrl){
          setToken(authorizationData);
      
        }
      }

      try{
        const mallAuthorization =
          fetchOptions.headers?.authorization || authorizationData || getMallAppToken();
        if (response._data) {
          await applyTransferTranslations({
            responseData: response._data,
            transferConfig: transferRequestConfig,
            mallAuthorization,
            translate: (payload) => batchTranslateTexts(payload, mallAuthorization),
          });

          if (typeof response._data.msg === "string" && response._data.msg.trim()) {
            response._data.msg = await translateResponseMessage(
              response._data.msg,
              mallAuthorization
            );
          }
        }
      }catch(e){
        console.log(e)
      }

      // 检查响应状态
      // if (
      //   !response.ok ||
      //   (typeof response._data.success == "boolean" && !response._data.success)
      // ) {
      //   throw new Error(response._data);
      // }

      // 处理响应头
      //  const resHeaders ={}// useResponseHeader(['openaccessjwt','tracking_query_meta'])

      // 如果响应中有新的 token，更新 store
      if (resHeaders.has("openaccessjwt")) {
        store.setTokenKeyMap(tokenKey, resHeaders.get("openaccessjwt"));
      }
 
      
      if(get(response._data,'data.configData.shopId')){
      
        store.setShopIdKeyMap(tokenKey, get(response._data,'data.configData.shopId'));
      }
      if(get(response._data,'data.configData.dealerShopId')){
        store.setDealerShopIdKeyMap(tokenKey, get(response._data,'data.configData.dealerShopId'));
        // persist dealerShopId to cookie (works on SSR and client)
        try {
          const dealerShopIdCookie = useCookie('dealerShopId', { path: '/' });
          dealerShopIdCookie.value = get(response._data,'data.configData.dealerShopId');
        } catch(e) {
          // no-op
        }
      } else if (get(response._data,'data.dealerShopId')){
        store.setDealerShopIdKeyMap(tokenKey, get(response._data,'data.dealerShopId'));
        // persist dealerShopId to cookie (works on SSR and client)
        try {
          const dealerShopIdCookie = useCookie('dealerShopId', { path: '/' });
          dealerShopIdCookie.value = get(response._data,'data.dealerShopId');
        } catch(e) {
          // no-op
        }
      }


      // 如果有 tracking_query_meta，将其存储在 localStorage
      if (resHeaders.has("tracking_query_meta") && process.client) {
        window.localStorage.setItem(
          "tracking_query_meta",
          resHeaders.get("tracking_query_meta")
        );
      }

      // 返回响应数据
      return response._data;
    } catch (error) {
      // 错误处理
      console.error(error);
      const errorMessage = error.message || "请求失败";

      // 错误码处理
      if (error.message.includes("401")&&!url.match('uncheck401=1')) {
        if (process.client) {
          // 客户端登录信息管理
          let isShopUrl = checkShopFetchUrl(url);
          let isMallUrl = checkMallFetchUrl(url);
          let isCollectionUrl = checkCollectionFetchUrl(url);
          if ((isMallUrl || isCollectionUrl||isShopUrl)&&!url.match('uncheck401=1')) {
            ElMessage({
              showClose: true,
              message: "请先登录",
              type: "error",
            });
            store.logout();
          } else {
            ElMessage({
              showClose: true,
              message: errorMessage,
              type: "error",
            });
          }
        }
      } else if (error.message.includes("403")) {
        if (process.server) {
          navigateTo("/error/forbidden");
        }
      } else if (error.message.includes("404")) {
        if (process.server) {
          navigateTo("/error/not-found");
        }
      } else if (error.message.includes("500")) {
        if (process.client) {
          ElMessage({
            showClose: true,
            message: errorMessage,
            type: "error",
          });
        }
      }

      throw error;
    }
  };

  // 将 customFetch 提供给 Nuxt 应用
  nuxtApp.provide("customFetch", customFetch);
});
